import { useEffect } from 'react';
import { CarrierSidebarPage } from '../constants/notificationSidebarAllocation';
import Logger from '../services/logger';

const CARRIER_ROUTE_ACK_ENTRIES_RAW: ReadonlyArray<{ pathPrefix: string; page: CarrierSidebarPage }> = [
  { pathPrefix: '/carrier/available-loads', page: 'availableLoads' },
  { pathPrefix: '/carrier/my-loads', page: 'myLoads' },
  { pathPrefix: '/carrier/payments', page: 'payments' },
  { pathPrefix: '/carrier/partners', page: 'partners' },
];

/** Longest-prefix-first so nested routes resolve to the correct sidebar page. */
const CARRIER_ROUTE_ACK_ENTRIES = [...CARRIER_ROUTE_ACK_ENTRIES_RAW].sort(
  (a, b) => b.pathPrefix.length - a.pathPrefix.length
);

export function resolveCarrierSidebarPageFromPath(pathname: string): CarrierSidebarPage | null {
  const normalized = pathname.replace(/\/$/, '') || '/';

  for (const { pathPrefix, page } of CARRIER_ROUTE_ACK_ENTRIES) {
    if (normalized === pathPrefix || normalized.startsWith(`${pathPrefix}/`)) {
      return page;
    }
  }

  return null;
}

/**
 * Ack carrier sidebar notifications on route land (refresh, deep link, in-app nav),
 * not only when the user clicks a sidebar NavLink.
 */
export function useCarrierSidebarRouteAck(
  markPageVisited: (page: CarrierSidebarPage) => Promise<void>,
  pathname: string
): void {
  useEffect(() => {
    const page = resolveCarrierSidebarPageFromPath(pathname);
    if (!page) return;

    void markPageVisited(page).catch((err) => {
      Logger.warn('[useCarrierSidebarRouteAck] Failed to ack sidebar page visit', {
        err,
        pathname,
        page,
      });
    });
  }, [pathname, markPageVisited]);
}
